// Výpis blogu a slovníčku (body.type-posts-listing) — tlačítko u článku, dlouhé datum,
// „Načíst další články“ místo stránkování. Texty a přepínače v shopDataLayer.blogListing.

function getBlogListingConfig() {
    return window.shopDataLayer && window.shopDataLayer.blogListing
        ? window.shopDataLayer.blogListing
        : null;
}

// "2026-09-10 13:08:58" → "10. září 2026" podle jazyka e-shopu
function formatBlogDate(datetime) {
    const parts = (datetime || "").split(" ")[0].split("-");
    if (parts.length !== 3) {
        return null;
    }

    const date = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    if (isNaN(date.getTime())) {
        return null;
    }

    const language = getShoptetDataLayer().language || "cs";
    return date.toLocaleDateString(language, { day: "numeric", month: "long", year: "numeric" });
}

function initBlogItems($items) {
    const config = getBlogListingConfig();
    if (!config) {
        return;
    }

    $items.each(function () {
        const $item = $(this);
        const $text = $item.find(".text");
        const $title = $text.find(".title");

        // Tlačítko jen jednou (idempotence po AJAX stránkování a načtení dalších)
        if (config.readMoreButton && $title.length && !$text.find(".myblog-read").length) {
            $("<a class='my-btn myblog-read'></a>")
                .attr("href", $title.attr("href"))
                .text(config.readMoreButton)
                .appendTo($text);
        }

        if (config.longDate) {
            $text.find("time[datetime]").each(function () {
                const formatted = formatBlogDate($(this).attr("datetime"));
                if (formatted) {
                    $(this).text(formatted);
                }
            });
        }
    });
}

function initBlogLoadMore() {
    const config = getBlogListingConfig();
    if (!config || !config.loadMore || !config.loadMore.enabled) {
        return;
    }

    const $controls = $(".type-posts-listing .listingControls");
    const $next = $controls.find(".pagination__link--next");
    // Třída zůstává i po načtení poslední strany → tlačítko se znovu nevloží
    if (!$controls.length || $controls.hasClass("myblog-more-active") || !$next.length) {
        return;
    }

    $controls.addClass("myblog-more-active");

    $("<div class='myblog-more'>" +
        "<a class='my-btn main-btn myblog-more-button'></a>" +
    "</div>").prependTo($controls);

    $controls.find(".myblog-more-button")
        .attr("href", $next.attr("href"))
        .text(config.loadMore.text);
}

window.initBlogListing = function () {
    if (!$("body").hasClass("type-posts-listing")) {
        return;
    }

    initBlogItems($("#newsWrapper .news-item"));
    initBlogLoadMore();
};

$(document).ready(function () {
    window.initBlogListing();
});

["ShoptetDOMContentLoaded", "ShoptetDOMPageContentLoaded"].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
        window.initBlogListing();
    });
});

// Stav výpisu v history.state (stejné URL) — kolik dalších stran je načteno a kde čtenář byl
function saveBlogListingState(extra) {
    const state = $.extend({}, history.state, extra);
    try {
        history.replaceState(state, "");
    } catch (e) {}
}

// Načte stranu z href tlačítka, připojí jen chybějící články. Promise: resolve(true/false = je další strana)
function loadNextBlogPage($button) {
    const deferred = $.Deferred();
    const $wrapper = $button.closest(".myblog-more");
    const url = $button.attr("href");

    if ($button.hasClass("is-loading") || !url) {
        return deferred.reject(url).promise();
    }

    $button.addClass("is-loading").attr("aria-busy", "true");

    $.get(url, function (data) {
        const $response = $($.parseHTML(data));
        const nextUrl = $response.find(".listingControls .pagination__link--next").attr("href");
        const known = $("#newsWrapper .news-item .title").map(function () {
            return $(this).attr("href");
        }).get();

        // Bez duplicit (článek mohl mezitím přibýt a posunout stránkování)
        const $newItems = $response.find("#newsWrapper .news-item").filter(function () {
            return known.indexOf($(this).find(".title").attr("href")) === -1;
        });

        $newItems.appendTo("#newsWrapper");
        initBlogItems($newItems);

        const loaded = (history.state && history.state.myblogLoaded ? history.state.myblogLoaded : 0) + 1;
        saveBlogListingState({ myblogLoaded: loaded });

        // Stav tlačítka se vrací před resolve, aby navazující načtení (obnova) nebylo zablokované
        $button.removeClass("is-loading").removeAttr("aria-busy");

        if (nextUrl) {
            $button.attr("href", nextUrl);
        } else {
            $wrapper.remove();
        }

        deferred.resolve(!!nextUrl);
    }, "html").fail(function () {
        $button.removeClass("is-loading").removeAttr("aria-busy");
        deferred.reject(url);
    });

    return deferred.promise();
}

$(document).on("click", ".type-posts-listing .myblog-more-button", function (e) {
    e.preventDefault();

    loadNextBlogPage($(this)).fail(function (url) {
        // Při chybě klasický přechod na další stranu
        if (url) {
            window.location.href = url;
        }
    });
});

// Pozice před odchodem na článek
$(document).on("click", ".type-posts-listing #newsWrapper a", function () {
    saveBlogListingState({ myblogScroll: window.scrollY });
});

window.addEventListener("pagehide", function () {
    if (document.body && document.body.classList.contains("type-posts-listing")) {
        saveBlogListingState({ myblogScroll: window.scrollY });
    }
});

// Zpět na výpis: dotáhne dříve načtené strany a vrátí čtenáře na původní místo
const blogNavigation = window.performance && performance.getEntriesByType ? performance.getEntriesByType("navigation")[0] : null;
const blogRestoreState = history.state && history.state.myblogLoaded ? history.state : null;

if (blogRestoreState && blogNavigation && blogNavigation.type === "back_forward" && "scrollRestoration" in history) {
    history.scrollRestoration = "manual";
}

$(document).ready(function () {
    const isBackForward = blogNavigation && blogNavigation.type === "back_forward";

    if (!blogRestoreState || !$("body").hasClass("type-posts-listing")) {
        return;
    }

    // Běžné načtení → stav se zahodí, ukáže se jen první strana
    if (!isBackForward) {
        saveBlogListingState({ myblogLoaded: 0, myblogScroll: 0 });
        return;
    }

    const pages = blogRestoreState.myblogLoaded;
    const scroll = blogRestoreState.myblogScroll || 0;
    const $button = $(".type-posts-listing .myblog-more-button");

    saveBlogListingState({ myblogLoaded: 0 });

    const finish = function () {
        $button.removeClass("is-restoring");
        window.scrollTo(0, scroll);
        if ("scrollRestoration" in history) {
            history.scrollRestoration = "auto";
        }
    };

    if (!$button.length) {
        finish();
        return;
    }

    $button.addClass("is-restoring");

    const step = function (remaining) {
        if (remaining <= 0) {
            finish();
            return;
        }

        loadNextBlogPage($button).done(function (hasNext) {
            if (hasNext) {
                step(remaining - 1);
            } else {
                finish();
            }
        }).fail(finish);
    };

    step(pages);
});
